export const passwordPolicyDescription =
  'Your password must be 8–128 characters and contain at least one uppercase letter, one lowercase letter, one number, and one special character.';

const minimumPasswordLength = 8;
const maximumPasswordLength = 128;
const upperCaseRegex = /[A-Z]/;
const lowerCaseRegex = /[a-z]/;
const numberRegex = /[0-9]/;
const specialCharacterRegex = /[\x21-\x2D\x2F\x3A-\x40\x5B-\x5E\x60\x7B-\x7E]/;

export function getPasswordValidationError(password: string, confirmedPassword: string) {
  if (password.length < minimumPasswordLength || password.length > maximumPasswordLength) {
    return `Your password must be between ${minimumPasswordLength} and ${maximumPasswordLength} characters in length.`;
  }

  if (password !== confirmedPassword) {
    return 'Both passwords do not match.';
  }

  if (
    !upperCaseRegex.test(password) ||
    !lowerCaseRegex.test(password) ||
    !numberRegex.test(password) ||
    !specialCharacterRegex.test(password)
  ) {
    return 'Your password must contain at least one uppercase letter, one lowercase letter, one number, and one special character.';
  }

  return '';
}
